import {ReactNode} from 'react';

import {APIProvider} from '@vis.gl/react-google-maps';

import {googleApisKey} from '~/shared/config';
import {getLocalizationService} from '~/shared/services/localisationService';

type MapProviderProps = {
  onLoad?: () => void;
  onError?: (error: unknown) => void;
  children: ReactNode;
};

const GoogleMapsAPIProvider = ({children, onLoad, onError}: MapProviderProps) => {
  const {currentLanguageKey} = getLocalizationService();

  return (
    <APIProvider
      apiKey={googleApisKey}
      region="IL"
      language={currentLanguageKey}
      onLoad={onLoad}
      onError={onError}
    >
      {children}
    </APIProvider>
  );
};

export default GoogleMapsAPIProvider;
